// extracted by mini-css-extract-plugin
module.exports = {"stepTitle":"EditApplicationForm_stepTitle__3N2dj","documentsUploadDescription":"EditApplicationForm_documentsUploadDescription__3Zg_t"};